/*
 * @forgerock/ping-javascript-sdk
 *
 * policy.types.ts
 *
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
var PolicyKey;
(function (PolicyKey) {
    PolicyKey["CannotContainCharacters"] = "CANNOT_CONTAIN_CHARACTERS";
    PolicyKey["CannotContainDuplicates"] = "CANNOT_CONTAIN_DUPLICATES";
    PolicyKey["CannotContainOthers"] = "CANNOT_CONTAIN_OTHERS";
    PolicyKey["LeastCapitalLetters"] = "AT_LEAST_X_CAPITAL_LETTERS";
    PolicyKey["LeastNumbers"] = "AT_LEAST_X_NUMBERS";
    PolicyKey["MatchRegexp"] = "MATCH_REGEXP";
    PolicyKey["MaximumLength"] = "MAX_LENGTH";
    PolicyKey["MaximumNumber"] = "MAXIMUM_NUMBER_VALUE";
    PolicyKey["MinimumLength"] = "MIN_LENGTH";
    PolicyKey["MinimumNumber"] = "MINIMUM_NUMBER_VALUE";
    PolicyKey["Required"] = "REQUIRED";
    PolicyKey["Unique"] = "UNIQUE";
    PolicyKey["UnknownPolicy"] = "UNKNOWN_POLICY";
    PolicyKey["ValidArrayItems"] = "VALID_ARRAY_ITEMS";
    PolicyKey["ValidDate"] = "VALID_DATE";
    PolicyKey["ValidEmailAddress"] = "VALID_EMAIL_ADDRESS_FORMAT";
    PolicyKey["ValidNameFormat"] = "VALID_NAME_FORMAT";
    PolicyKey["ValidNumber"] = "VALID_NUMBER";
    PolicyKey["ValidPhoneFormat"] = "VALID_PHONE_FORMAT";
    PolicyKey["ValidQueryFilter"] = "VALID_QUERY_FILTER";
    PolicyKey["ValidType"] = "VALID_TYPE";
})(PolicyKey || (PolicyKey = {}));
export { PolicyKey };
